export default __webpack_public_path__ + "static/media/two_kids_blue_tarmac.56060df5.jpg";